<template>
<div class="writeCardApplyList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">空中写号申请列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="ICCID:">
                <el-input v-model="form.iccid" placeholder="请输入ICCID"></el-input>
            </el-form-item>
            <el-form-item label="接入号:">
                <el-input v-model="form.phone" placeholder="请输入接入号"></el-input>
            </el-form-item>
            <el-form-item label="写号状态:">
                <el-select v-model="form.writeStatus" placeholder="请选择写号状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待写号" value="0"></el-option>
                    <el-option label="写号中" value="1"></el-option>
                    <el-option label="已写号" value="2"></el-option>
                    <el-option label="写号失败" value="3"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="开始时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.startTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="结束时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.endTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-delete" class="themed-button" @click="batchDelete">批量删除</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-back" class="themed-button" @click="exportExcel">批量导出</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importData">导入</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="接入号" prop="phone" show-overflow-tooltip></el-table-column>
            <el-table-column label="写号状态" prop="writeStatus" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatWriteStatus(scope.row.writeStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="当前省份" prop="province" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.updateTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.writeStatus === '0' || scope.row.writeStatus === 0" type="primary" size="mini" class="themed-button" @click="handleWrite(scope.row)">写卡</el-button>
                    <el-button type="primary" size="mini" class="themed-button" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.writeStatus === '0' || scope.row.writeStatus === 0" type="danger" size="mini" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 写卡弹框 -->
    <el-dialog title="写卡" :visible.sync="writeDialogVisible" width="500px">
        <el-form :model="writeForm" label-width="100px">
            <el-form-item label="省份:" required>
                <el-select v-model="writeForm.province" placeholder="请选择省份">
                    <el-option
                        v-for="(label, value) in provinceMap"
                        :key="value"
                        :label="label"
                        :value="label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitWrite">确 定</el-button>
            <el-button class="themed-button" type="primary" @click="writeDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 编辑弹框 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="500px">
        <el-form :model="editForm" label-width="100px">
            <el-form-item label="接入号:" required>
                <el-input v-model="editForm.phone" placeholder="请输入接入号"></el-input>
            </el-form-item>
            <el-form-item label="当前省份:" required>
                <el-select v-model="editForm.province" placeholder="请选择省份">
                    <el-option
                        v-for="(label, value) in provinceMap"
                        :key="value"
                        :label="label"
                        :value="label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitEdit">确 定</el-button>
            <el-button class="themed-button" type="primary" @click="editDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:">
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="设备卡信息:">
                <el-input v-model="importCardInfo" type="textarea" rows="6" placeholder="请输入ICCID 接入号 省份(省份为非必填)，每行一组，用空格分开"></el-input>
                <div style="color:#f00;">请输入ICCID 接入号 省份(省份为非必填)，每行一组，用空格分开</div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="importDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量删除弹框 -->
    <el-dialog title="批量删除" :visible.sync="deleteDialogVisible" width="500px">
        <div style="color:#f00; margin-bottom: 15px; font-size: 14px;">
            <i class="el-icon-warning"></i> 注意：只能删除写号状态为"待写号"的卡
        </div>
        <el-form label-position="right" label-width="200px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:">
                <input class="file-input" type="file" ref='deleteFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="ICCID信息:">
                <el-input v-model="deleteIccidInfo" type="textarea" rows="6" placeholder="请输入ICCID或短号，每行一个"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitBatchDelete">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportDeleteTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="deleteDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listWriteCardApply, 
    deleteById, 
    exportWriteCardApply, 
    importExcel, 
    batchDelete, 
    writeCard, 
    editCard
} from '@/api/writeCardManagement/writeCardApplyList.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'writeCardApplyList',
    mixins: [resize],
    data() {
        return {
            form: {
                iccid: '',
                phone: '',
                writeStatus: '',
                startTime: '',
                endTime: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 写卡弹框数据
            writeDialogVisible: false,
            writeForm: {
                id: '',
                province: ''
            },

            // 编辑弹框数据
            editDialogVisible: false,
            editForm: {
                id: '',
                phone: '',
                province: ''
            },
            
            // 省份映射数据
            provinceMap: {
                '北京市': '北京市', 
                '天津市': '天津市',
                '河北省': '河北省',
                '山西省': '山西省',
                '内蒙古自治区': '内蒙古自治区',
                '辽宁省': '辽宁省',
                '吉林省': '吉林省', 
                '黑龙江省': '黑龙江省',
                '上海市': '上海市',
                '江苏省': '江苏省',
                '浙江省': '浙江省',
                '安徽省': '安徽省',
                '福建省': '福建省',
                '江西省': '江西省',
                '山东省': '山东省',
                '河南省': '河南省',
                '湖北省': '湖北省',
                '湖南省': '湖南省',
                '广东省': '广东省',
                '广西壮族自治区': '广西壮族自治区',
                '海南省': '海南省',
                '重庆市': '重庆市',
                '四川省': '四川省',
                '贵州省': '贵州省',
                '云南省': '云南省',
                '西藏自治区': '西藏自治区',
                '陕西省': '陕西省',
                '甘肃省': '甘肃省',
                '青海省': '青海省',
                '宁夏回族自治区': '宁夏回族自治区',
                '新疆维吾尔自治区': '新疆维吾尔自治区',
                '台湾省': '台湾省',
                '香港特别行政区': '香港特别行政区',
                '澳门特别行政区': '澳门特别行政区',
                '全国': '全国',
            },

            // 导入弹框数据
            importDialogVisible: false,
            importCardInfo: '',

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteIccidInfo: ''
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listWriteCardApply(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导出
        exportExcel() {
            exportWriteCardApply(this.form).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 删除单条
        deleteById(row) {
            // 检查写号状态，只有待写号的卡才能删除
            if (row.writeStatus !== '0' && row.writeStatus !== 0) {
                this.$message.warning('只能删除待写号的卡')
                return
            }
            
            confirmBox(this, `确定要删除ICCID为 ${row.iccid} 的记录吗？`, '操作提示', () => {
                deleteById({ id: row.id }).then(res => {
                    messageBox(this, '删除成功')
                    this.getList()
                })
            })
        },

        // 写卡操作
        handleWrite(row) {
            // 显示写号提示
            this.$confirm('写号申请成功后会更新旧卡号信息为新卡号信息，如需查询新卡号信息请到空中写号申请记录查询。是否确认继续写号操作？', '写号提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.province) {
                    // 如果已有省份，直接发起写卡
                    this.submitWriteCard(row.id, row.province)
                } else {
                    // 如果没有省份，打开弹窗选择
                    this.writeForm = {
                        id: row.id,
                        province: ''
                    }
                    this.writeDialogVisible = true
                }
            }).catch(() => {
                // 用户取消操作
            })
        },

        // 提交写卡
        submitWrite() {
            if (!this.writeForm.province) {
                this.$message.warning('请选择省份')
                return
            }

            this.submitWriteCard(this.writeForm.id, this.writeForm.province)
        },

        // 发起写卡请求
        submitWriteCard(id, province) {
            writeCard({
                id: id,
                province: province
            }).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || '写卡成功')
                    this.writeDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.system_result_message_key || '写卡失败')
                }
            })
        },

        // 编辑操作
        handleEdit(row) {
            this.editForm = {
                id: row.id,
                phone: row.phone,
                province: row.province
            }
            this.editDialogVisible = true
        },

        // 提交编辑
        submitEdit() {
            if (!this.editForm.phone || !this.editForm.province) {
                this.$message.warning('请填写必要信息')
                return
            }

            editCard(this.editForm).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || '编辑成功')
                    this.editDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.system_result_message_key || '编辑失败')
                }
            }).catch(err => {
                this.$message.error('编辑失败，请稍后重试')
                console.error(err)
            })
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            let formData = new FormData();
            
            // 处理卡信息
            if (!file && !this.importCardInfo.trim()) {
                messageBox(this, '请选择文件或输入申请信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('applyInfos', this.importCardInfo);
            
            importExcel(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (file) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['importFile'].value = '';
                            this.importCardInfo = '';
                            this.importDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.importCardInfo = '';
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出模板
        exportTemplate() {//模板修改importWriteCardApplyList.xls
            exportTemplate({name: 'importWriteCardApplyList.xls'}).then(res => {
                const filename = 'importWriteCardApplyList.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs['deleteFile'].files[0];
            let formData = new FormData();
            
            // 处理ICCID信息
            if (!file && !this.deleteIccidInfo.trim()) {
                messageBox(this, '请选择文件或输入ICCID信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加ICCID信息到表单
            formData.append('deleteInfos', this.deleteIccidInfo);
            
            // 添加确认提示
            this.$confirm('批量删除只能删除写号状态为"待写号"的卡，其他状态的卡将被忽略。确定要继续吗？', '批量删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                batchDelete(formData).then(res => {
                    if (res.system_result_key == '0') {
                        this.$alert(res.system_result_message_key || '删除成功', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            if (file) this.$refs['deleteFile'].value = '';
                            this.deleteIccidInfo = '';
                            this.deleteDialogVisible = false;
                            this.getList();
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: 'error'
                        })
                    }
                })
            }).catch(() => {
                // 用户取消操作，不需要做任何处理
            })
        },

        // 导出删除模板
        exportDeleteTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 格式化写号状态
        formatWriteStatus(status) {
            const statusMap = {
                '0': '待写号',
                '1': '写号中',
                '2': '已写号',
                '3': '写号失败'
            };
            return statusMap[status] || '-';
        }
    }
}
</script>

<style scoped>
.writeCardApplyList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.info-box {
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style> 